import React from 'react'
import TrfSettings from '../../../components/trf-settings'

const TrfPage = () => {
  return <TrfSettings/>
}

export default TrfPage

